import { render, staticRenderFns } from "./BattleManage.vue?vue&type=template&id=11d64a8f&scoped=true&"
import script from "./BattleManage.vue?vue&type=script&lang=js&"
export * from "./BattleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d64a8f",
  null
  
)

export default component.exports